import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=febb70ae&scoped=true&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"
import style0 from "./Logout.vue?vue&type=style&index=0&id=febb70ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febb70ae",
  null
  
)

component.options.__file = "Logout.vue"
export default component.exports